import CardItem from 'slickpay/online/CardItem.component';

import { DEPOSIT_CARD_IMAGES, NO_SHOW_CARD_IMAGES, PROTECTION_CARD_IMAGES } from 'constants/images/slickPay.const';
import { useCountryImage } from 'hooks/useCountryImage.hook';
import { useHelpLinks } from 'hooks/useHelpLinks.hook';
import { useTranslation } from 'providers/GILT.provider';

import CN from './ThreeCards.module.scss';

const ThreeCards = () => {
  const { t } = useTranslation();
  const { slickPayDepositsHelpLink, slickPayDepositRequestHelpLink, slickPayNoShowHelpLink } = useHelpLinks();

  const protectionCardImage = useCountryImage(PROTECTION_CARD_IMAGES);
  const depositCardImage = useCountryImage(DEPOSIT_CARD_IMAGES);
  const noShowCardImage = useCountryImage(NO_SHOW_CARD_IMAGES);

  return (
    <div data-bem="ThreeCards" className={CN.space}>
      <div className={CN.header}>
        <div className={CN.title}>{t('slickPay.onlinePayments.title')}</div>
      </div>
      <div className={CN.container} data-bem="ThreeCards__container">
        <CardItem imageSrc={protectionCardImage} title={t('slickPay.onlinePayments.protectionTitle')} link={slickPayDepositsHelpLink} />
        <div className={CN.middleCard}>
          <CardItem imageSrc={depositCardImage} title={t('slickPay.onlinePayments.depositTitle')} link={slickPayDepositRequestHelpLink} />
        </div>

        <CardItem imageSrc={noShowCardImage} title={t('slickPay.onlinePayments.noShowTitle')} link={slickPayNoShowHelpLink} />
      </div>
    </div>
  );
};
export default ThreeCards;
